<template>
  <button
    type="button"
    class="gs-more"
    :class="['is-' + size, { 'is-muted': muted }]"
    @click="$emit('click', $event)"
  >
    <span class="gs-more-label"><slot>更多</slot></span>
    <svg class="gs-more-icon" viewBox="0 0 22 20" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M9.05 4.45a1.1 1.1 0 0 1 1.56 0l4.2 4.2a1.25 1.25 0 0 1 0 1.7l-4.2 4.2a1.1 1.1 0 1 1-1.56-1.56L12.4 10 9.05 6.65a1.1 1.1 0 0 1 0-1.56Z"
      />
      <path
        fill="currentColor"
        opacity="0.55"
        d="M2.85 4.45a1.1 1.1 0 0 1 1.56 0l4.2 4.2a1.25 1.25 0 0 1 0 1.7l-4.2 4.2a1.1 1.1 0 1 1-1.56-1.56L6.2 10 2.85 6.65a1.1 1.1 0 0 1 0-1.56Z"
      />
    </svg>
  </button>
</template>

<script>
export default {
  name: 'GsMore',
  props: {
    size: { type: String, default: 'md' },
    muted: { type: Boolean, default: false }
  },
  emits: ['click']
}
</script>

<style scoped>
.gs-more {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin: 0;
  padding: 2px 6px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #8a9099;
  cursor: pointer;
  line-height: 1;
  white-space: nowrap;
  flex-shrink: 0;
  font: inherit;
  transition: color 0.22s ease, background-color 0.22s ease, transform 0.22s ease;
}
.gs-more.is-muted {
  color: #8a9099;
}
.gs-more:not(.is-muted) {
  color: #5b6b82;
}
.gs-more:hover {
  color: #0165ff;
  background-color: rgba(1, 101, 255, 0.1);
  transform: translateX(2px);
}
.gs-more:active {
  transform: translateX(3px) scale(0.98);
}
.gs-more:hover .gs-more-icon {
  transform: translateX(2px);
}
.gs-more-label {
  font-size: 14px;
  font-weight: 500;
  transition: color 0.22s ease;
}
.gs-more-icon {
  width: 18px;
  height: 16px;
  display: block;
  flex: 0 0 auto;
  transition: transform 0.22s ease;
}
.gs-more.is-sm .gs-more-label {
  font-size: 12px;
}
.gs-more.is-sm .gs-more-icon {
  width: 15px;
  height: 14px;
}
.gs-more.is-xs .gs-more-label {
  font-size: 11px;
}
.gs-more.is-xs .gs-more-icon {
  width: 12px;
  height: 12px;
}
@media (max-width: 960px) {
  .gs-more-label {
    font-size: 12px;
  }
  .gs-more-icon {
    width: 16px;
    height: 14px;
  }
  .gs-more.is-sm .gs-more-label,
  .gs-more.is-xs .gs-more-label {
    font-size: 11px;
  }
  .gs-more.is-sm .gs-more-icon,
  .gs-more.is-xs .gs-more-icon {
    width: 14px;
    height: 12px;
  }
}
</style>
